import { render, staticRenderFns } from "./FormulationCompositionSettings.vue?vue&type=template&id=c6b4f5ac&scoped=true&"
import script from "./FormulationCompositionSettings.vue?vue&type=script&lang=js&"
export * from "./FormulationCompositionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b4f5ac",
  null
  
)

export default component.exports